
export default {
  namespace: 'moduleList',
  state: {
    data: {}
  } /*
  reducers: {
    saveCartoon (state, action) {
      return { ...state, ...action.payload }
    }
  },
  effects: {
    * get ({ payload }, {call, put}) {
      const cartoonMsg = yield call(getCartoon)
      yield put({
        type: 'saveCartoon',
        payload: {
          cartoonMsg: cartoonMsg
        }
      })
    }
  } */

}
